import React, { useEffect } from 'react';
import cancel from './../../../static/icons/cancel.svg';
import warning from '../../../static/images/rbac_auth.svg';
import styles from './accessErrorModal.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import { setAccessError } from '../../../app/appSlice';

export const AccessErrorModal = () => {

  const dispatch = useDispatch();

  const accessError = useSelector(state => state.app.accessError)

  const handleAccessError = () => {
    dispatch(setAccessError(null))
  }

  useEffect(() => {
    if (accessError !== null) {
      document.body.classList.add('modal-open');
      return () => {
        document.body.classList.remove('modal-open');
      };
    }
  }, [accessError]);


  return (
    <>
      {accessError && <div
        className={styles.popup}
        id="modalWindow"
        data-testid="modalWindow"
      >
        {/* <div className="popup_inner"> */}
        <div className={`${styles.ws_modal_xl} ${styles.delete_conf}`}>
          <div className={`modal-dialog modal-dialog-scrollable modal-dialog-centered`} style={{ width: '800px' }}>
            <div className={`modal-content rounded-0 ${styles.ws_modal_content}`}>
              {/* <div className={`modal-header ${ws_modal_header}`}>
                <h5 className={`modal-title ${custom_title}`}></h5>
                <button to="#" data-testid="close" onClick={handleAccessError} className={`${close_btn}`}>
                  <img src={cancel} alt="Close" />
                </button>
              </div> */}
              
              <div className={styles.main_content}>
                <img src={warning} alt="Close" />
                
                <div className={`${styles.opps_txt}`}>Oops…</div>
                <div className={`${styles.opps_msg}`}>{accessError.toString()}</div>
                <button  data-testid="close" onClick={handleAccessError} className={`${styles.opps_btn}`}>
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>}
    </>
  );
};
